import { useShowPagedCustomItems } from "../../hooks"
import { ShowCustomArticleItemsRequest } from "../models"
import { showCustomArticleItems } from "../showCustomArticleItems"
import { QUERY_KEY_ARTICLES } from "./keys"

export function useShowCustomArticleItems(request: Omit<ShowCustomArticleItemsRequest, "pageIndex" | "pageSize">) {
    return useShowPagedCustomItems(request, { queryKey: [QUERY_KEY_ARTICLES, request.query], dataFn: showCustomArticleItems })
}
